import { Supplier } from '../../../Quotes/types/supplier';
import { doRequest, Methods } from '../../../Request';

interface IUpdateCustomerPreferencesRequestBody {
  data: {
    attributes: {
      allowed_suppliers: Supplier[];
      allowed_cloud_connect_providers: string[];
    };
    type: 'customer';
  };
}

export const updateCustomerPreferences = (companyId: string, selectedSuppliers: Supplier[], selectedCloudConnectProviderValues: string[]) => {
  // Default suppliers (basically Neos themselves) to be added to every PATCH request.
  const defaultSuppliers = [Supplier.NNAT, Supplier.NONE];
  const body: IUpdateCustomerPreferencesRequestBody = {
    data: {
      attributes: {
        allowed_suppliers: selectedSuppliers.concat(defaultSuppliers),
        allowed_cloud_connect_providers: selectedCloudConnectProviderValues
      },
      type: 'customer',
    },
  };

  return doRequest({
    body,
    method: Methods.PATCH,
    path: `/customers/${companyId}`,
  });
};
